import {Colors} from "@bounce/shared/ui";

export const LIST_HEADER_HEIGHT = 44;

export const listCardSx = {
  borderRadius: "8px",
  border: `1px solid ${Colors.tertiary._300}`,
  backgroundColor: Colors.bw.white,
  boxShadow: "0 1px 2px rgba(0, 0, 0, 0.04)",
  overflow: "hidden",
} as const;

export const listHeaderBandSx = {
  backgroundColor: Colors.tertiary._200,
  borderBottom: `1px solid ${Colors.tertiary._300}`,
} as const;
